// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-12qs7hp-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 7.5px 14px !important;
}

.css-17qar0e-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 7.5px 14px !important;
}

.css-10ncwuj-MuiFormLabel-root-MuiInputLabel-root {
  top: -9px !important;
}

.rom-timepicker {
  border-radius: 15px;
  height: 45px;
  border: 1px solid #bfbfbf;
  padding: 7.5px 14px !important;
}

.rom-timepickerdark {
  border-radius: 15px;
  background: #2c2c38;
  height: 45px;
  color: #f6f7f8;
  border: 1px solid #bfbfbf;
}

input.rom-timepicker {
  width: -webkit-fill-available !important;
}

.react-datepicker-wrapper {
  width: -webkit-fill-available !important;
}

.react-datepicker__time-container {
  width: 147px;
}

.react-datepicker__time-container,
.react-datepicker__time,
.react-datepicker__time-box ul.react-datepicker__time-list {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.react-datepicker__time-container::-webkit-scrollbar,
.react-datepicker__time::-webkit-scrollbar,
.react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar {
  width: 0;
  height: 0;
}

@media only screen and (max-width: 450px) {
  .mob-av {
    max-height: 100vh !important;
    overflow: scroll !important;
    display: block !important;
    padding-left: 0%;
    padding-right: 0%;
  }
}
@media only screen and (min-width: 450px) {
  .desk-av {
    overflow: auto;
    max-height: 100vh;
    display: flex !important;
    flex-wrap: nowrap !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/auth/choose-availability/choose-availability.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;;AADA;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;AAIF;;AAFA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AAKF;;AAFA;EACE,wCAAA;AAKF;;AAFA;EACE,wCAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;;;EAGE,cAAA;EACA,qBAAA;EACA,wCAAA;AAKF;;AAFA;;;EAGE,QAAA;EACA,SAAA;AAKF;;AAFA;EACE;IACE,4BAAA;IACA,2BAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EAKF;AACF;AAHA;EACE;IACE,cAAA;IACA,iBAAA;IACA,wBAAA;IACA,4BAAA;EAKF;AACF","sourcesContent":[".css-12qs7hp-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 7.5px 14px !important;\n}\n.css-17qar0e-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 7.5px 14px !important;\n}\n.css-10ncwuj-MuiFormLabel-root-MuiInputLabel-root {\n  top: -9px !important;\n}\n.rom-timepicker {\n  border-radius: 15px;\n  height: 45px;\n  border: 1px solid #bfbfbf;\n  padding: 7.5px 14px !important;\n}\n.rom-timepickerdark {\n  border-radius: 15px;\n  background: #2c2c38;\n  height: 45px;\n  color: #f6f7f8;\n  border: 1px solid #bfbfbf;\n}\n\ninput.rom-timepicker {\n  width: -webkit-fill-available !important;\n}\n\n.react-datepicker-wrapper {\n  width: -webkit-fill-available !important;\n}\n\n.react-datepicker__time-container {\n  width: 147px;\n}\n\n.react-datepicker__time-container,\n.react-datepicker__time,\n.react-datepicker__time-box ul.react-datepicker__time-list {\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n.react-datepicker__time-container::-webkit-scrollbar,\n.react-datepicker__time::-webkit-scrollbar,\n.react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n@media only screen and (max-width: 450px) {\n  .mob-av {\n    max-height: 100vh !important;\n    overflow: scroll !important;\n    display: block !important;\n    padding-left: 0%;\n    padding-right: 0%;\n  }\n}\n@media only screen and (min-width: 450px) {\n  .desk-av {\n    overflow: auto;\n    max-height: 100vh;\n    display: flex !important;\n    flex-wrap: nowrap !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
